import { render, staticRenderFns } from "./ProductGroupItem.vue?vue&type=template&id=4f317356"
import script from "./ProductGroupItem.vue?vue&type=script&lang=js"
export * from "./ProductGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports